module.exports = __webpack_public_path__ + "static/institutionLogoMadisonCollege-098fcb5663557b152fd9ad7c38e83f0c.png";